export const CONVERSION_EVENTS = ['calculator_started', 'calculator_results_viewed', 'calculator_brief_copied', 'calculator_brief_downloaded', 'calculator_enquiry_handoff', 'pdf_requested', 'scenario_submitted', 'enquiry_submitted', 'booking_clicked', 'service_cta_clicked'] as const;
export type ConversionEvent = typeof CONVERSION_EVENTS[number];
export type ConversionContext = 'investment' | 'owner-occupied' | 'rent-roll' | 'commercial' | 'business' | 'home' | 'website';
const contexts: readonly string[] = ['investment', 'owner-occupied', 'rent-roll', 'commercial', 'business', 'home', 'website'];
/** Strict allowlist: never include financial figures, names, tenant details, URLs or free text. */
export function conversionPayload(event: ConversionEvent, context: ConversionContext) {
  if (!(CONVERSION_EVENTS as readonly string[]).includes(event) || !contexts.includes(context)) return null;
  return { event, context };
}
/** Analytics parameters are intentionally derived from allowlisted values only.
 * Query strings and fragments can contain calculator state, so they are never sent. */
export function conversionAnalyticsParameters(context: ConversionContext, location: Pick<Location, 'origin' | 'pathname'>) {
  if (!contexts.includes(context)) return null;
  return {
    calculator_context: context,
    page_location: location.origin + location.pathname,
    page_referrer: '',
  };
}
export function trackConversion(event: ConversionEvent, context: ConversionContext = 'website') {
  const payload = conversionPayload(event, context);
  if (!payload || typeof window === 'undefined' || navigator.doNotTrack === '1') return;
  const analyticsWindow = window as Window & { dataLayer?: unknown[] };
  // Use only the site's existing GA queue; no new vendor, storage or network endpoint.
  if (!analyticsWindow.dataLayer) return;
  function enqueue(..._args: unknown[]) { analyticsWindow.dataLayer!.push(arguments); }
  enqueue('event', payload.event, conversionAnalyticsParameters(payload.context, window.location));
}
export function installConversionClicks() {
  const handler = (event: MouseEvent) => {
    const target = event.target instanceof Element ? event.target.closest('a') : null;
    if (!target) return;
    const url = new URL(target.href, window.location.origin);
    if (url.hostname === 'cal.com') trackConversion('booking_clicked');
    else if (url.origin === window.location.origin && url.pathname === '/contact') trackConversion('service_cta_clicked');
  };
  document.addEventListener('click', handler);
  return () => document.removeEventListener('click', handler);
}
